<template>
  <service-view
    :pictures="pictures"
    :serviceTitle="serviceTitle"
    :householdActive="'active'"
    :serviceDescription="serviceDescription"
  />
</template>
<script>
import ServiceView from "./ServiceView";
export default {
  name: "HouseholdFittings",
  components: {
    ServiceView
  },
  data: () => ({
    pictures: [
      {
        name: "household/IMG-20170723-WA0036.jpg",
        title: "Constructing a factory",
        location: "Zambia"
      },
      {
        name: "household/IMG-20180315-WA0006.jpg",
        title: "Swimming pool construction",
        location: "Zambia"
      },
      {
        name: "household/IMG-20180315-WA0004.jpg",
        title: "Constructing a factory",
        location: "Zambia"
      },
      {
        name: "household/IMG-20170723-WA0035.jpg",
        title: "Swimming pool construction",
        location: "Zambia"
      },
      {
        name: "household/IMG-20170723-WA0010.jpg",
        title: "Swimming pool construction",
        location: "Zambia"
      }
    ],
    serviceTitle: "Household fittings",
    serviceDescription:
      "Kitchen units, wooden counters, granite counters and wardrooms design and fitting."
  })
};
</script>
